export default __webpack_public_path__ + "static/media/8bdcd49447aa27887de75bd1da152e381581606208149.6bc33cf6.webp";